// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.border-dotted {\n  border: 2px dashed #3278ff;\n  border-radius: 7px;\n}\n", ""]);
// Exports
module.exports = exports;
